(function () {
  const BLOCK_SELECTOR = '[data-finch-variant-details]';

  const VARIANT_EVENTS = [
    'variant:change',
    'variantChange',
    'variant-change',
    'change'
  ];

  function parseData(block) {
    const el = block.querySelector('[data-finch-variant-data]');
    if (!el) return null;

    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.warn('Finch variant details JSON error', e);
      return null;
    }
  }

  function getContext(block) {
    return (
      block.closest('#hdt-quick-view-modal') ||
      block.closest('.hdt-main-product-quick-view') ||
      block.closest('.hdt-product-info__list') ||
      block.closest('.shopify-section') ||
      document
    );
  }

  function getForm(block) {
    const formId = block.dataset.formId;

    if (formId && document.forms[formId]) {
      return document.forms[formId];
    }

    const context = getContext(block);

    return (
      context.querySelector('form.hdt-main-product-form') ||
      context.querySelector('form[action*="/cart/add"]')
    );
  }

  function getVariantFromEvent(event, data) {
    const id = event?.detail?.variant?.id;
    if (!id) return null;

    return data.variants.find(function (v) {
      return String(v.id) === String(id);
    }) || null;
  }

  function getVariantFromForm(block, data) {
    const form = getForm(block);
    const input = form?.querySelector('input[name="id"], select[name="id"]');

    if (input?.value) {
      const variant = data.variants.find(function (v) {
        return String(v.id) === String(input.value);
      });

      if (variant) return variant;
    }

    const picker = getContext(block).querySelector('hdt-variant-picker[selected-variant]');

    if (picker?.getAttribute('selected-variant')) {
      const variant = data.variants.find(function (v) {
        return String(v.id) === String(picker.getAttribute('selected-variant'));
      });

      if (variant) return variant;
    }

    return (
      data.variants.find(function (v) {
        return String(v.id) === String(data.selectedVariantId);
      }) ||
      data.variants[0] ||
      null
    );
  }

  function unitLabel(unit) {
    if (!unit) return 'cm';

    const value = String(unit).toLowerCase();

    if (value.includes('centimeter') || value === 'cm') return 'cm';
    if (value.includes('millimeter') || value === 'mm') return 'mm';
    if (value.includes('meter') || value === 'm') return 'm';
    if (value.includes('inch') || value === 'in') return 'in';

    return unit;
  }

  function formatDimension(value, unit) {
    if (value === null || value === undefined || value === '') return '—';
    return `${value} ${unitLabel(unit)}`;
  }

  function buildTitle(baseTitle, variant, data) {
    let colour = '';
    let size = '';

    if (!variant?.options || !data?.options) {
      return baseTitle || data?.productTitle || '';
    }

    data.options.forEach(function (optionName, index) {
      const optionValue = variant.options[index];
      if (!optionValue) return;

      const name = String(optionName).toLowerCase();

      if (name === 'colour' || name === 'color') {
        colour = optionValue;
      }

      if (name === 'size') {
        size = optionValue;
      }
    });

    let title = baseTitle || data.productTitle || '';

    if (colour && !title.toLowerCase().includes(String(colour).toLowerCase())) {
      title = `${colour} ${title}`;
    }

    if (size && !title.toLowerCase().includes(String(size).toLowerCase())) {
      title = `${title} ${size}`;
    }

    return title;
  }

  function updateSeoTitle(newTitle, block) {
    const isQuickView = !!block.closest('#hdt-quick-view-modal, .hdt-main-product-quick-view');
    if (isQuickView) return;

    const currentTitle = document.title;
    const pipeIndex = currentTitle.indexOf('|');
    const suffix = pipeIndex >= 0 ? currentTitle.substring(pipeIndex) : '';

    document.title = `${newTitle}${suffix ? ' ' + suffix : ''}`;

    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', newTitle);

    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) twitterTitle.setAttribute('content', newTitle);
  }

  function updateBlock(block, variantOverride) {
    const data = parseData(block);
    if (!data?.variants?.length) return;

    const variant = variantOverride || getVariantFromForm(block, data);
    if (!variant) return;

    const heightEl = block.querySelector('[data-finch-height]');
    const widthEl = block.querySelector('[data-finch-width]');
    const depthEl = block.querySelector('[data-finch-depth]');
    const weightEl = block.querySelector('[data-finch-weight]');
    const deliverySizeEl = block.querySelector('[data-finch-delivery-size]');

    if (heightEl) {
      heightEl.textContent = formatDimension(variant.heightValue, variant.heightUnit);
    }

    if (widthEl) {
      widthEl.textContent = formatDimension(variant.widthValue, variant.widthUnit);
    }

    if (depthEl) {
      depthEl.textContent = formatDimension(variant.depthValue, variant.depthUnit);
    }

    if (weightEl) {
      weightEl.textContent = variant.weight || '—';
    }

    if (deliverySizeEl) {
      deliverySizeEl.textContent = variant.deliverySize || '—';
    }

    const context = getContext(block);

    let titleEls = context.querySelectorAll('.hdt-dynamic-product-title[data-base-title]');

    if (!titleEls.length && block.closest('#hdt-quick-view-modal, .hdt-main-product-quick-view')) {
      titleEls = context.querySelectorAll('.hdt-product__title h1, .hdt-product__title h2, .hdt-product__title h3');
    }

    titleEls.forEach(function (titleEl) {
      if (!titleEl.dataset.baseTitle) {
        titleEl.dataset.baseTitle = data.productTitle || titleEl.textContent.trim();
      }

      const newTitle = buildTitle(titleEl.dataset.baseTitle, variant, data);

      titleEl.textContent = newTitle;
      updateSeoTitle(newTitle, block);
    });
  }

  function bindBlock(block) {
    if (block.dataset.finchVariantDetailsBound === 'true') {
      updateBlock(block);
      return;
    }

    block.dataset.finchVariantDetailsBound = 'true';

    if (
      block.closest('.hdt-main-product-quick-view') ||
      block.closest('#hdt-quick-view-modal')
    ) {
      block.classList.add('is-quickview');
    }


    const form = getForm(block);

    if (form) {
      VARIANT_EVENTS.forEach(function (eventName) {
        form.addEventListener(eventName, function (event) {
          const data = parseData(block);
          const eventVariant = data ? getVariantFromEvent(event, data) : null;

          updateBlock(block, eventVariant);

          setTimeout(function () {
            updateBlock(block);
          }, 80);
        });
      });
    }

    const context = getContext(block);

    context.addEventListener('click', function () {
      setTimeout(function () {
        updateBlock(block);
      }, 120);
    }, true);

    updateBlock(block);

    setTimeout(function () {
      updateBlock(block);
    }, 150);

    setTimeout(function () {
      updateBlock(block);
    }, 400);
  }

  function bindAll() {
    document.querySelectorAll(BLOCK_SELECTOR).forEach(bindBlock);
  }

  function boot() {
    bindAll();

    setTimeout(bindAll, 150);
    setTimeout(bindAll, 400);
    setTimeout(bindAll, 900);
  }

  document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', boot);

  document.addEventListener('click', function () {
    setTimeout(bindAll, 250);
    setTimeout(bindAll, 650);
  }, true);
})();